import { useAtom } from 'jotai'

import { selectSystemModeStore } from 'src/stores'

export const useSelectSystemModeStore = () => {
  const [selectSystemModeStoreValue, setSelectSystemModeStoreValue] = useAtom(
    selectSystemModeStore.state
  )

  return {
    selectSystemModeStoreValue,
    setSelectSystemModeStoreValue,
  }
}
